import React, { PropsWithChildren } from 'react';
import { useStyles } from './styles';

interface IOptionProps<TData = unknown> {
  value: TData;
  onSelected?: (product: TData | null) => void;
}

export function Option<TData = unknown>({ value, onSelected, children }: PropsWithChildren<IOptionProps<TData>>) {
  const classes = useStyles();

  return (
    <button className={classes.buttonItem} onClick={() => onSelected?.(value)}>
      {children}
    </button>
  );
}
